<template>
  <nav-bar title="检查" />
  <RoleName role="付货检查人员" />
  <Content :bottom="120" :top="98" @content-scroll="handleContentScroll">
    <Loading v-if="showLoading" :isLoading="isLoading" @reload="getList" />
    <div class="title">
      <span>{{ list[0] && list[0].departmentName }}</span>
      <span>空瓶</span>
      <span>{{ list.length }}</span>
    </div>
    <ul class="list">
      <li class="list-item list-title van-hairline--bottom">
        <span class="list-item__gsId">瓶号</span>
        <span class="list-item__residua-gas">介质</span>
        <span class="list-item__residua-gas">重量</span>
        <span>
          <!-- <span>全选</span> -->
          <van-checkbox
            v-model="checkedAll"
            shape="square"
            @click="handleCheckedAllClick"
          />
        </span>
      </li>
      <van-checkbox-group v-model="checked" ref="checkboxGroup">
        <li
          class="list-item list-child"
          v-for="item in list"
          :key="item.gsCode"
        >
          <span class="list-item__gsId">{{ item.gsCode }}</span>
          <span class="list-item__residua-gas">{{ item.pname }}</span>
          <span class="list-item__residua-gas">{{ item.gsCapacity }}</span>
          <span>
            <van-checkbox :name="item.gsCode" shape="square" />
          </span>
        </li>
      </van-checkbox-group>
    </ul>

    <loading-more
      :finished="finished"
      :showLoadingMore="showLoadingMore"
      :loadingFail="loadingFail"
      :list="list"
      @reload="getList"
    />
  </Content>
  <div v-if="!showLoading" class="btn-conatiner van-hairline--top">
    <van-row v-show="inputShow" gutter="16">
      <van-col span="24">
        <van-field
          ref="pdaCode"
          label="扫码结果"
          placeholder="请按动PDA上的扫码按钮"
          @update:model-value="pdaScan"
          v-model="resultStr"
        />
      </van-col>
    </van-row>
    <van-row gutter="16">
      <van-col span="24">
        <van-button
          block
          icon="scan"
          native-type="button"
          @click="handlePdaCodeClick"
        >
          PDA扫码
        </van-button>
      </van-col>
    </van-row>
    <van-button
      block
      type="primary"
      native-type="button"
      :disabled="!checked.length"
      @click="handlePopClick"
    >
      {{ checked.length ? '检查' : '至少选中一项11' }}
    </van-button>
  </div>
  <Popup title="确认交付检查项内容" ref="checkPopup" minHeight="100%">
    <van-field label-width="45%" label="充装量在规定范围内">
      <template #input>
        <van-radio-group v-model="radios.czl" direction="horizontal">
          <van-radio name="1">是</van-radio>
          <van-radio name="2">否</van-radio>
        </van-radio-group>
      </template>
    </van-field>
    <van-field label-width="45%" label="瓶阀及其余瓶口连接的密封良好">
      <template #input>
        <van-radio-group v-model="radios.mf" direction="horizontal">
          <van-radio name="1">良好</van-radio>
          <van-radio name="2">否</van-radio>
        </van-radio-group>
      </template>
    </van-field>
    <van-field label-width="45%" label="瓶体未出现鼓包变形或泄露等严重缺陷">
      <template #input>
        <van-radio-group v-model="radios.gb" direction="horizontal">
          <van-radio name="1">无</van-radio>
          <van-radio name="2">有</van-radio>
        </van-radio-group>
      </template>
    </van-field>
    <van-field label-width="45%" label="瓶体温度没有异常升高的迹象">
      <template #input>
        <van-radio-group v-model="radios.yc" direction="horizontal">
          <van-radio name="1">无</van-radio>
          <van-radio name="2">有</van-radio>
        </van-radio-group>
      </template>
    </van-field>
    <van-field label-width="45%" label="气瓶粘贴警示标签和充装标签">
      <template #input>
        <van-radio-group v-model="radios.tag" direction="horizontal">
          <van-radio name="1">已粘贴</van-radio>
          <van-radio name="2">未粘贴</van-radio>
        </van-radio-group>
      </template>
    </van-field>
    <van-field label-width="30%" label="检查结果">
      <template #input>
        <van-radio-group v-model="result" direction="horizontal">
          <van-radio
            v-for="item in columns"
            :name="item.code"
            :key="item.code"
            :disabled="item.disabled"
            >{{ item.dicValMean }}</van-radio
          >
        </van-radio-group>
      </template>
    </van-field>
    <div class="btn">
      <van-button type="primary" @click="handleCheckConfirm" block
        >确认</van-button
      >
    </div>
  </Popup>
</template>

<script>
import { ref, computed, watch, nextTick } from 'vue'
import {
  cylinderSummaryDetail,
  addFillApplyCheckAfter
} from '@/api/cylinderManageUserHome'
import { useLoadingMore } from '@/hooks/useLoadingMore'
import { useChecked } from '@/hooks/useChecked'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { Toast, Notify, Dialog } from 'vant'
export default {
  name: 'PayGoodsDetail', // 付货
  props: ['departmentId', 'applyId', 'appStatus', 'empId'],
  setup(props) {
    const store = useStore()
    const router = useRouter()
    const empId = computed(() => store.state.roleInfo.empId)
    const data = useLoadingMore(cylinderSummaryDetail)
    const { getList, list, finished, loadingFail, pageParams } = data

    // 初始化list
    const init = () => {
      list.value = []
      pageParams.departmentId = props.departmentId
      pageParams.applyId = props.applyId
      pageParams.appStatus = props.appStatus
      pageParams.empId = props.empId
      pageParams.summaryType = '1'
      pageParams.page = 1
      pageParams.pageNum = 15
      finished.value = false
      loadingFail.value = false

      getList()
    }
    init()

    // 选择钢瓶
    const { checkedAll, checked, checkboxGroup, handleCheckedAllClick } =
      useChecked(list)
    const aftCheck = ref('')
    // 检查表

    const showRes = ref(false)
    const columns = ref([
      {
        dicValMean: '通过',
        code: '1',
        disabled: false
      },
      {
        dicValMean: '维修',
        code: '2',
        disabled: false
      },
      {
        dicValMean: '报废',
        code: '3',
        disabled: false
      }
    ])
    const radios = ref({
      czl: '1',
      gb: '1',
      mf: '1',
      tag: '1',
      yc: '1'
    })
    const radiosVal = computed(() => {
      const arr = []
      for (const key in radios.value) {
        arr.push(radios.value[key])
      }
      return arr
    })
    watch(radios.value, (val) => {
      const isSome = radiosVal.value.some((item) => item === '2')
      if (isSome) {
        result.value = '2'
        columns.value[0].disabled = true
      } else {
        result.value = '1'
        columns.value[0].disabled = false
      }
    })
    const checkPopup = ref(null)
    const handlePopClick = () => {
      checkPopup.value.showPopup()
    }
    const result = ref('1')
    const comfirmRes = () => {
      const params = {
        applyId: props.applyId,
        deptId: props.departmentId,
        empId: empId.value,
        result: result.value,
        bGlmFillCheckPre: {
          ...radios.value
        },
        codeArr: checked.value.join(',')
      }
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        overlay: true,
        message: '请稍后...'
      })
      addFillApplyCheckAfter(params)
        .then(() => {
          Notify({ type: 'success', message: '操作成功' })
          Toast.clear()
          router.back()
        })
        .catch(() => {
          Toast.clear()
        })
    }
    const handleCheckConfirm = () => {
      if (result.value !== '1') {
        Dialog.confirm({
          title: '提示',
          message: '检查不通过钢瓶将保持现有状态，是否确定？'
        })
          .then(() => {
            // on confirm
            comfirmRes()
          })
          .catch(() => {
            // on cancel
          })
      } else {
        comfirmRes()
      }
    }
    const inputShow = ref(false)
    const resultStr = ref('')
    const pdaCode = ref(null)
    const handlePdaCodeClick = async () => {
      inputShow.value = true
      await nextTick()
      if (pdaCode.value) {
        pdaCode.value.focus()
      }
    }
    const pdaScan = (v) => {
      const f = list.value.find((item) => item.qrCode === v)
      if (f && !checked.value.includes(f.gsCode)) {
        checked.value.push(f.gsCode)
      }
      resultStr.value = ''
    }
    return {
      radio: '1',
      list,
      checkedAll,
      checked,
      aftCheck,
      checkboxGroup,
      handleCheckedAllClick,
      checkPopup,
      handlePopClick,
      handleCheckConfirm,
      ...data,
      radios,
      columns,
      confirm,
      showRes,
      result,
      inputShow,
      pdaScan,
      handlePdaCodeClick,
      resultStr
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  margin: 16px;
  color: #666;
  font-size: 14px;
  span {
    margin-right: 5px;
  }
  span:last-child {
    font-weight: 600;
    color: #000;
  }
}
.list {
  font-size: 14px;
  padding: 0 16px;
  .list-item {
    display: flex;
    align-items: center;
    &__gsId {
      flex: 1;
    }
    &__residua-gas {
      margin: 0 50px 0 10px;
      width: 50px;
      text-align: right;
    }
  }
  .list-title {
    padding-bottom: 5px;
    margin-bottom: 5px;
  }
  .list-child {
    margin-bottom: 10px;
    &:nth-child(odd) {
      background-color: #fff;
    }
    &:nth-child(even) {
      background-color: #ededed;
    }
  }
}
.btn-conatiner {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
}
.btn {
  margin: 16px;
}
</style>
